export default "__VITE_ASSET__BFr4aGW9__"